import DashView from './components/Dash.vue'
import LoginView from './components/Login.vue'
import NotFoundView from './components/404.vue'
import RedefinirSenha from './components/RedefinirSenha.vue'
import Home from './components/Home.vue'

// Import Views - Dash
import DashboardView from './components/views/Dashboard.vue'
import TablesView from './components/views/Tables.vue'
import SettingView from './components/views/Setting.vue'
import ReposView from './components/views/Repos.vue'
import ClientesView from './components/views/Clientes.vue'
import ProdutosView from './components/views/Produtos.vue'
import NovoProduto from './components/views/NovoProduto.vue'
import NovaCategoria from './components/views/NovaCategoria.vue'
import Categorias from './components/views/Categorias.vue'
import Pedidos from './components/views/Pedidos/Pedidos.vue'
import RelatoriosPedidos from './components/views/Pedidos/Relatorios.vue'
import NovoUsuario from './components/views/NovoUsuario.vue'
import MinhaConta from './components/views/MinhaConta.vue'
import AlterarEmail from './components/views/AlterarEmail.vue'
import AlterarSenha from './components/views/AlterarSenha.vue'
import CondPagto from './components/views/CondPagto'
import NovaCondPagto from './components/views/NovaCondPagto'
import OrderCategoria from './components/views/OrderCategoria'
import OrderProduto from './components/views/OrderProduto'
import NotificarClientes from './components/views/NotificarClientes'
import Calendario from './components/views/Calendario'
import Servicos from './components/views/Servicos/Servicos'
import NovoServico from './components/views/Servicos/novoServico'
import ServicoCategorias from './components/views/ServicoCategorias/ServicoCategorias'
import Funcionarios from './components/views/Funcionarios/Funcionarios'
import NovoColaborador from './components/views/Funcionarios/novoFuncionario.vue'
import NovaCategoriaServicos from './components/views/ServicoCategorias/novaCategoria'
import ProblemasSolucao from './components/views/Problemas/Problemas'
import NovoProblema from './components/views/Problemas/novoProblema'
import Help from './components/views/Help/help'
import Solicitacoes from './components/views/Solicitacoes/Solicitacoes'
import PacotesViagens from './components/views/PacotesViagens/PacotesViagens'
import NovoPacoteViagem from './components/views/PacotesViagens/novoPacote'
import PerguntasPersonalizas from './components/views/PerguntasPersonalizadas/PerguntasPersonalizadas'
import NovaPergunta from './components/views/PerguntasPersonalizadas/novaPergunta'
import Filtros from './components/views/Filtros/Filtros'
import NovoFiltro from './components/views/Filtros/novoFiltro'
import DetalheSolicitacao from './components/views/Solicitacoes/detalhe'
import InclusaoRapidaProdutos from './components/views/InclusaoRapida/InclusaoRapidaProdutos'
import InclusaoRapidaCategorias from './components/views/InclusaoRapida/InclusaoRapidaCategorias'
import Campanhas from './components/views/Campanhas/Campanhas'
import NovaCampanha from './components/views/Campanhas/novaCampanha'

// Routes
const routes = [
  {
    path: '/login',
    component: LoginView
  },
  {
    path: '/redefinir-senha',
    component: RedefinirSenha
  },
  {
    path: '/',
    component: DashView,
    children: [
      {
        path: 'dashboard',
        alias: '',
        component: DashboardView,
        name: 'Pagina Inicial',
        meta: {requiresAuth: true}
      }, {
        path: 'tables',
        component: TablesView,
        name: 'Tables',
        meta: {requiresAuth: true}
      }, {
        path: 'setting',
        component: SettingView,
        name: 'Configurações',
        meta: {requiresAuth: true}
      }, {
        path: 'repos',
        component: ReposView,
        name: 'Repository',
        meta: {requiresAuth: true}
      }, {
        path: 'clientes',
        component: ClientesView,
        name: 'Clientes',
        meta: {requiresAuth: true}
      }, {
        path: 'clientes/notificar',
        component: NotificarClientes,
        name: 'NotificarClientes',
        meta: {requiresAuth: true}
      }, {
        path: 'produtos',
        component: ProdutosView,
        name: 'Produtos',
        meta: {requiresAuth: true}
      }, {
        path: 'novo-produto',
        component: NovoProduto,
        name: 'Novo Produto',
        meta: {
          requiresAuth: true
        }
      },
      {
        path: 'produtos/:id/editar',
        component: NovoProduto,
        name: 'editarProduto',
        meta: {
          requiresAuth: true
        }
      }, {
        path: 'produtos/ordem',
        component: OrderProduto,
        name: 'orderProduto',
        meta: {
          requiresAuth: true
        }
      }, {
        path: 'categorias',
        component: Categorias,
        name: 'Categorias',
        meta: {
          requiresAuth: true
        }
      }, {
        path: 'nova-categoria',
        component: NovaCategoria,
        name: 'NovaCategoria',
        meta: {
          requiresAuth: true
        }
      }, {
        path: 'categorias/:id/editar',
        component: NovaCategoria,
        name: 'editarCategoria',
        meta: {
          requiresAuth: true
        }
      }, {
        path: 'categorias/ordem',
        component: OrderCategoria,
        name: 'orderCategoria',
        meta: {
          requiresAuth: true
        }
      }, {
        path: 'pedidos',
        component: Pedidos,
        name: 'Pedidos',
        meta: {
          requiresAuth: true
        }
      }, {
        path: 'pedidos/relatorios',
        component: RelatoriosPedidos,
        name: 'Relatório de Pedidos',
        meta: {
          requiresAuth: true
        }
      }, {
        path: 'novo-usuario',
        component: NovoUsuario,
        name: 'Novo Usuario',
        meta: {
          requiresAuth: true
        }
      }, {
        path: 'minha-conta',
        component: MinhaConta,
        name: 'Minha Conta',
        meta: {
          requiresAuth: true
        }
      }, {
        path: 'alterar-email',
        component: AlterarEmail,
        name: 'Alterar Email',
        meta: {
          requiresAuth: true
        }
      }, {
        path: 'alterar-senha',
        component: AlterarSenha,
        name: 'Alterar Senha',
        meta: {
          requiresAuth: true
        }
      }, {
        path: 'condpagto',
        component: CondPagto,
        name: 'Condição de Pagamento',
        meta: {
          requiresAuth: true
        }
      } , {
        path: 'nova-condpagto',
        component: NovaCondPagto,
        name: 'Nova Condição de Pagamento',
        meta: {
          requiresAuth: true
        }
      }, {
        path: 'calendario',
        component: Calendario,
        name: 'Calendário',
        meta: {
          requiresAuth: true
        }
      }, {
        path: 'servicos',
        component: Servicos,
        name: 'Servicos',
        meta: {
          requiresAuth: true
        }
      }, {
        path: 'novo-servico',
        component: NovoServico,
        name: 'Novo Serviço',
        meta: {
          requiresAuth: true
        }
      }, {
        path: 'servicos/:id/editar',
        component: NovoServico,
        name: 'Editar Serviço',
        meta: {
          requiresAuth: true
        }
      }, {
        path: 'categorias-servicos',
        component: ServicoCategorias,
        name: 'Categoria de Servicos',
        meta: {
          requiresAuth: true
        }
      }, {
        path: 'nova-categoriaservicos',
        component: NovaCategoriaServicos,
        name: 'Nova Categoria de Servicos',
        meta: {
          requiresAuth: true
        }
      },{
        path: 'categoria-servicos/:id/editar',
        component: NovaCategoriaServicos,
        name: 'editarCategoriadeServicos',
        meta: {
          requiresAuth: true
        }
      }, {
        path: 'colaborador',
        component: Funcionarios,
        name: 'Colaborador',
        meta: {
          requiresAuth: true
        }
      }, {
        path: 'novo-colaborador',
        component: NovoColaborador,
        name: 'Novo Colaborador',
        meta: {
          requiresAuth: true
        }
      }, {
        path: 'colaborador/:id/editar',
        component: NovoColaborador,
        name: 'Editar Colaborador',
        meta: {
          requiresAuth: true
        }
      }, {
        path: 'problemas',
        component: ProblemasSolucao,
        name: 'Problemas e Soluções',
        meta: {
          requiresAuth: true
        }
      }, {
        path: 'novo-problema',
        component: NovoProblema,
        name: 'Novo Problema e Soluções',
        meta: {
          requiresAuth: true
        }
      }, {
        path: 'problemas/:id/editar',
        component: NovoProblema,
        name: 'Editar Problema',
        meta: {
          requiresAuth: true
        }
      }, {
        path: 'help',
        component: Help,
        name: 'Ajuda',
        meta: {
          requiresAuth: true
        }
      }, {
        path: 'solicitacoes',
        component: Solicitacoes,
        name: 'Solicitacoes',
        meta: {
          requiresAuth: true
        }
      }, {
        path: 'solicitacoes/:id',
        component: DetalheSolicitacao,
        name: 'Detalhe Solicitação',
        meta: {
          requiresAuth: true
        }
      }, {
        path: 'pacotes',
        component: PacotesViagens,
        name: 'Pacotes',
        meta: {
          requiresAuth: true
        }
      }, {
        path: 'novo-pacote',
        component: NovoPacoteViagem,
        name: 'Novo Pacote',
        meta: {
          requiresAuth: true
        }
      }, {
        path: 'pacotes/:id/editar',
        component: NovoPacoteViagem,
        name: 'Editar Pacote',
        meta: {
          requiresAuth: true
        }
      }, {
        path: 'filtros',
        component: Filtros,
        name: 'Filtros',
        meta: {
          requiresAuth: true
        }
      }, {
        path: 'novo-filtro',
        component: NovoFiltro,
        name: 'Novo Filtro',
        meta: {
          requiresAuth: true
        }
      }, {
        path: 'filtros/:id/editar',
        component: NovoFiltro,
        name: 'Editar Filtro',
        meta: {
          requiresAuth: true
        }
      }, {
        path: 'perguntas',
        component: PerguntasPersonalizas,
        name: 'Perguntas Personalizadas',
        meta: {
          requiresAuth: true
        }
      }, {
        path: 'nova-pergunta',
        component: NovaPergunta,
        name: 'Nova Pergunta',
        meta: {
          requiresAuth: true
        }
      }, {
        path: 'perguntas/:id/editar',
        component: NovaPergunta,
        name: 'Editar Pergunta',
        meta: {
          requiresAuth: true
        }
      }, {
        path: 'inclusao-rapida-produtos',
        component: InclusaoRapidaProdutos,
        name: 'Inclusão Rádida de Produtos',
        meta: {
          requiresAuth: true
        }
      }, {
        path: 'inclusao-rapida-categorias',
        component: InclusaoRapidaCategorias,
        name: 'Inclusão Rádida de Categorias',
        meta: {
          requiresAuth: true
        }
      }, {
        path: 'campanhas',
        component: Campanhas,
        name: 'Campanhas',
        meta: {
          requiresAuth: true
        }
      }, {
        path: 'nova-campanha',
        component: NovaCampanha,
        name: 'Nova Campanha',
        meta: {
          requiresAuth: true
        }
      }, {
        path: 'campanhas/:id/editar',
        component: NovaCampanha,
        name: 'Editar Campanha',
        meta: {
          requiresAuth: true
        }
      }
    ]
  }, {
    // not found handler
    path: '*',
    component: NotFoundView
  }
]

export default routes


// WEBPACK FOOTER //
// ./src/router.map.js